import * as stylex from "@stylexjs/stylex";
import { springConfigs } from "charts/lib/motion";
import { AnimatePresence, motion } from "framer-motion";
import { useRTL } from "hooks";
import Link from "next/link";
import { E, pipe } from "prelude";
import { useMemo } from "react";
import Highlighter from "react-highlight-words";
import { getAliasHref, RAlias } from "routes";
import { breakpoints, colors } from "../../materials/consts.stylex";
import lunr from "../../search/lunr";
const Results = (props)=>{
    const { searchIndex, query } = props;
    const idx = useMemo(()=>lunr.Index.load(searchIndex.idx), [
        searchIndex.idx
    ]);
    const results = idx.search(query ? `${query}*~2` : "");
    const isRTL = useRTL();
    return <ul {...{
        0: {
            className: "x11gisft xysyzu8 x12peec7 x12oqio5 x1mqxbix xhtitgo x2ra7ta x1uhb9sk x1ugatxu xh8yej3 xo9wytw xuyqlj2 x11l0c42 x1xmf6yo xo1zb4t x3m8u43 x1t8mvi6"
        },
        1: {
            className: "x11gisft xysyzu8 x12peec7 x12oqio5 x1mqxbix xhtitgo x2ra7ta x1uhb9sk x1ugatxu xh8yej3 xo9wytw xuyqlj2 x11l0c42 x1xmf6yo xo1zb4t xwukr4l xu96u03"
        }
    }[!!isRTL << 0]}>
      <AnimatePresence>
        {results.map((d)=>{
        const match = Object.values(searchIndex.pages).find((x)=>x.id === d.ref);
        const keywords = Object.keys(d.matchData.metadata);
        if (!match || [
            "figure",
            "figures"
        ].includes(match.filename)) {
            return null;
        }
        return pipe(RAlias.decode(match.filename), E.fold(()=>null, (alias)=><motion.li key={d.ref} initial={{
                opacity: 0
            }} exit={{
                opacity: 0
            }} animate={{
                opacity: 1
            }} // The <mark> highlight color/weight is set in style.global.css, scoped by
            // this class — react-highlight-words' <Highlighter> renders <mark> itself,
            // an element we don't render, so StyleX can't reach it directly.
            className={`search-result-item ${({
                className: "xe8ttls x1ypdohk x1m0wovr x9v0ylq x5z6fxw"
            }).className}`} layout transition={springConfigs.slow}>
                  <Link href={getAliasHref(alias)} {...{
                0: {
                    className: "xng3xce xjbqb8w xhlp2gg xi99i6s xdpxx8g"
                },
                1: {
                    className: "xng3xce xjbqb8w xhlp2gg xi99i6s x1hr2gdg"
                }
            }[!!isRTL << 0]} tabIndex={0}>
                    <b className="x1lliihq">
                      <Highlighter searchWords={keywords} autoEscape={true} textToHighlight={match.title ?? ""}/>
                    </b>
                    <Highlighter searchWords={keywords} autoEscape={true} textToHighlight={`${match.description.substring(0, 100)} [...]`}/>
                  </Link>
                </motion.li>));
    })}
      </AnimatePresence>
    </ul>;
};
export const SearchComponent = (props)=>{
    const isRTL = useRTL();
    return <div {...{
        0: {
            className: "x1yf7rl7 xw7yly9 xo1zb4t xj3b58b x1fdcg62"
        },
        1: {
            className: "xj3b58b xw7yly9 xo1zb4t x1yf7rl7 x1uj1h4e"
        }
    }[!!isRTL << 0]} {...props}/>;
};
export const SearchInput = (props)=>{
    return <input className="xgqmno8 xng3xce x1t137rt xbyyjgo x1rxi9p xh8yej3 x1vuk045 x1ff1495 x1tq3lug x4gyw5p" type="search" {...props}/>;
};
export default Results;
